module.exports = __webpack_public_path__ + "static/media/BunburyHerald-socshare-min.7f87c573.jpg";